import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const ChevronUp = ({ className = '', fill = '#4E4B5B', height = 16, width = 16 }) => {
  return (
    <div
      style={{
        width,
        height,
      }}
      className={classnames('svg', 'svg-chevron-up', className)}
    >
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style={{ display: 'block' }}>
        <path d="M8 6.606 4.37 10l-1.037-.97L8 4.667l4.667 4.363-1.037.97L8 6.606z" fill={fill} />
      </svg>

    </div>
  );
};

ChevronUp.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default ChevronUp;
